import React from 'react';
import PropTypes from 'prop-types';



const SearchAddressItem = (props) => {
    const handleSearchAddress = (location, address) => () => {
        props.selectedAdress(location, address);
    }
    return(
        <li onClick={handleSearchAddress(props.location, props.address)}>{props.address}</li>
    )
}

export default SearchAddressItem;

SearchAddressItem.propTypes = {
    address: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    selectedAdress: PropTypes.func.isRequired
}